/* Copyright (c) 2020 Pej AB. All rights reserved.
 * Created by Marcus Johansson on 2020-02-11. */

export class PejPrinter {
    public serialNumber: string;
    public target: string; // TODO: check manual for what this is exactly
    public vendor: string;
}
